const menu = {
    namespaced: true,
    state: {
        menuColl: false,
        nowRoute: '' // 当前路由 tabs切换使用
    },
    mutations: {
        menuColl: (state, x) => {
            state.menuColl = !state.menuColl
        },
        nowRoute: (state, x) => {
            state.nowRoute = x
        },


    },
    actions: {
        switchMenuColl({commit},data) {
            commit('menuColl',data)
        },
        switchTab({commit},data) {
            commit('nowRoute',data)
        }
    }
}
export default menu
